import type { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import {
  SEARCH_QUERY,
  SEARCH_TILE_HYDRATION_QUERY,
} from './ai-search-queries'
import { SEARCH_PAGE_RESULTS_HYDRATE_KEY } from './ssrSearchPageResults'

function isRecord (value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function writeApolloSeed (
  client: ApolloClient<NormalizedCacheObject>,
  seed: unknown,
  query: typeof SEARCH_QUERY | typeof SEARCH_TILE_HYDRATION_QUERY,
) {
  if (!isRecord(seed)) {
    return
  }
  const { apollo } = seed
  if (!isRecord(apollo) || !apollo.data || !apollo.variables) {
    return
  }
  try {
    client.writeQuery({
      query,
      variables: apollo.variables as Record<string, unknown>,
      data: apollo.data as Record<string, unknown>,
    })
  } catch {
    // Cache seed is best-effort; client still falls back to network.
  }
}

/**
 * Apollo cache seeds for SSR search page (Search + SearchTileHydration).
 */
export default function restoreApolloSearchPageSeeds (
  client: ApolloClient<NormalizedCacheObject>,
  hydrate: Record<string, unknown> | undefined,
) {
  const seed = hydrate?.[SEARCH_PAGE_RESULTS_HYDRATE_KEY]
  if (!isRecord(seed)) {
    return
  }
  writeApolloSeed(client, seed.search, SEARCH_QUERY)
  if (seed.tileHydration) {
    writeApolloSeed(client, seed.tileHydration, SEARCH_TILE_HYDRATION_QUERY)
  }
}
